import React, { useState,useRef ,useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useGlobalContext } from '../../context'; // Update the import path as needed
import "./Navbar.css";
import logoImg from "../../images/logo.png";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { api } from '../../config';
import { type } from '@testing-library/user-event/dist/type';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  // const {searchType } = useGlobalContext();
  const { searchCriteria,setSearchCriteria } = useGlobalContext(); // Assuming setSearchCategory is from context
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const {setSearchTerm} = useGlobalContext();
  const {searchText, setSearchText}= useGlobalContext();
  const [toggleMenuSmall, setToggleMenuSmall] = useState(false);
  const [activeNav, setActiveNav] = useState("");
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null); // Ref for the navbar

  const [categories, setCategories] = useState([]);
  let navigate = useNavigate();
const handleBooks = () => {

  // let tempSearchTerm = searchText.trim(); // Use searchText directly
  setSearchText(""); // Clear the searchText state
  setSearchTerm("");
  setSearchCriteria(prevCriteria => ({
    ...prevCriteria, // Keep the existing state
    location: "book",

    isSearching: false,
  }))
  
  setToggleMenu(false); 
  setActiveNav("books");
  setToggleMenuSmall(false);
}
  useEffect(() => {
    const username = localStorage.getItem('username');
    fetchCategories();
    setIsLoggedIn(!!username); // Check if username exists in localStorage
  }, []);
  // useEffect(() => searchText?.current?.focus(), []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${api}/book_author/category`);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Failed to fetch categories', error);
    }
  };
  const  handleLogout = async () => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to home page)
        //console.log('User is already unauthenticated. Redirecting to home page...');
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }
    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }

    const response = await fetch(`${api}/users/logout`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}` // Include token in request header
      },
    body: JSON.stringify({user_id:user_id,token:decodedToken}),
  });
 let data = await response.json();
  //console.log(data);
  localStorage.removeItem('username'); // Remove username from localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  localStorage.removeItem('user_id');
  setIsLoggedIn(false); // Update isLoggedIn state

  
  };

  const handleNavbar = () => {setToggleMenu(!toggleMenu);}
  // const handleSmallNavbar = () => setToggleMenuSmall(!toggleMenuSmall);

  // const handleSmallNavbar = () => {
  //   if (toggleMenuSmall) {
  //     setToggleMenuSmall(false);
  //   }else{
  //     setToggleMenuSmall(true);

  //   }
  // };

  
  
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setToggleMenu(false);
        setToggleMenuSmall(false); // Also close small menu if it's open
      }
    };

    // Add event listener when the menu is open
    if (toggleMenu || toggleMenuSmall) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [toggleMenu, toggleMenuSmall]); // Depend on the open state of the menus

  const mainn_menu = () => {

   setSearchText(""); // Clear the searchText state
   setSearchTerm("");
   setActiveNav("main");
   setSearchCriteria(prevCriteria => ({
      ...prevCriteria, // Keep the existing state
      isSearching: false,
      location: "main",
      allFilter:"category",
      type: "journal",
   }));
   setToggleMenuSmall(false);
   setToggleMenu(false); // Close the dropdown after selecting an item
  };


const handleJournal = (categoryId, categoryname) => {
//   console.log("toggleMenuSmall");
// console.log(toggleMenuSmall);
setSearchText(""); // Clear the searchText state
setSearchTerm("");
  if (categoryId === 0 || categoryId === null) {

    if (window.innerWidth <= 992 && categoryId == null) {
      setToggleMenuSmall(!toggleMenuSmall);
      return null;
    }
      setSearchCriteria(prevCriteria => ({
        ...prevCriteria, // Keep the existing state
        isSearching: false,
        allFilter:"category",
        location: "journal",
        category:0
      }));
      navigate('/journal');

  } else {

     
      if (categoryId !== 0) {
        
        navigate('/journal/' + categoryId);
      } else {
        navigate('/journal');
      }
    
      // setSearchCriteria(prevCriteria => ({
      //   ...prevCriteria, // Keep the existing state
      //   location: "journal",

      //    allFilter:"about",
      //   isSearching: false,

      //   categoryname:categoryname
      // }));

  }
  setToggleMenuSmall(false); // Close the dropdown after selecting an item
  setToggleMenu(false);
  setActiveNav("journal");
};

  
  return (
    <nav className='navbar' id="navbar"  ref={navbarRef}>
      <div className='container navbar-content flex'>
        <div className='brand-and-toggler flex flex-sb'>
          <Link to="/" className='navbar-brand flex' onClick={() => {setToggleMenuSmall(false);mainn_menu()}}>
            <img src={logoImg} alt="site logo" />
            <span className='text-uppercase fw-7 fs-24 ls-1'></span>
          </Link>
          <button type="button" className='navbar-toggler-btn' onClick={handleNavbar}>
            <HiOutlineMenuAlt4 size={35} style={{ color: `${toggleMenu ? "#fff" : "#010101"}` }} />
          </button>
        </div>

        <div className={toggleMenu ? "navbar-collapse show-navbar-collapse" : "navbar-collapse"}>
          <ul className="navbar-nav">
            <li className={`nav-item ${activeNav === "main" ? "activeNav" : ""}`}>
              <Link to="/" className={`nav-link text-uppercase text-white fs-22 fw-6 ls-1  ${activeNav === "main" ? "activeNav" : ""}`} onClick={mainn_menu}>الرئيسة </Link>
            </li>

            <li className={`nav-item ${activeNav === "journal" ? "activeNav" : ""}`}>

                {window.innerWidth >= 992 ? (
                  <div onMouseEnter={() => setToggleMenuSmall(true)} onMouseLeave={() => setToggleMenuSmall(false)} onClick={() => setToggleMenuSmall(prevState => !prevState)} ref={dropdownRef}>
                  <Link to="/journal" onClick={(e) => {e.stopPropagation(); handleJournal(null, null);}} className={`nav-link text-uppercase text-white fs-22 fw-6 ls-1 ${activeNav === "journal" ? "activeNav" : ""}`}>
                    المجلات
                    <svg
                      className={`w-2.5 h-2.5 ms-2.5 ${toggleMenuSmall ? 'rotated' : ''}`}
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                      style={{
                        marginRight: "10px",
                        width: "13px",
                        transform: toggleMenuSmall ? "rotate(180deg)" : "none"
                      }}
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      ></path>
                    </svg>
                  </Link>
                  <div className={toggleMenuSmall ? "dropdown-menu show" : "dropdown-menu"}>
                  {categories.map((category) => (
                    <a key={category.category_id} className="dropdown-item" onClick={() => {handleJournal(category.category_id, category.category_name);setToggleMenuSmall(false)}}>
                      {category.category_id == 0  ? "كل المجلات" : category.category_name}
                    </a>
                  ))}
                </div>
                  </div>
                ) : (
                  <div  onClick={() => setToggleMenuSmall(false)} ref={dropdownRef}>                  
                  <div onClick={(e) => {e.stopPropagation(); handleJournal(null, null);}} className={`nav-link text-uppercase text-white fs-22 fw-6 ls-1 ${activeNav === "journal" ? "activeNav" : ""}`}>
                    المجلات
                    <svg
                      className={`w-2.5 h-2.5 ms-2.5 ${toggleMenuSmall ? 'rotated' : ''}`}
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                      style={{
                        marginRight: "10px",
                        width: "13px",
                        transform: toggleMenuSmall ? "rotate(180deg)" : "none"
                      }}
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      ></path>
                    </svg>
                  </div>
                  <div className={toggleMenuSmall ? "dropdown-menu show" : "dropdown-menu"}>
                  {categories.map((category) => (
                    <a key={category.category_id} className="dropdown-item" onClick={() => {handleJournal(category.category_id, category.category_name);}}>
                      {category.category_id == 0  ? "كل المجلات" : category.category_name}
                    </a>
                  ))}
                </div>
                  </div>
                )}
           

            </li>

            <li className={`nav-item ${activeNav === "books" ? "activeNav" : ""}`}>
              <Link to="/book" onClick={handleBooks} className= {`nav-link text-uppercase text-white fs-22 fw-6 ls-1  ${activeNav === "books" ? "activeNav" : ""}`}>الكتب</Link>
            </li>

            {isLoggedIn ? (
              <li className='nav-item'>
              <button className='nav-link text-uppercase text-white fs-22 fw-6 ls-1' onClick={handleLogout}>تسجيل خروج</button>
              </li>
            ):null}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;